import api from '/src/api.js';

export function getWelcomeSectionConfiguration (companyId, options = {}) {
	return api.get(`/companies/${companyId}/configurations/welcome-section`, options);
}

export function getCodeCredentialsConfiguration (companyId, options = {}) {
	return api.get(`/companies/${companyId}/configurations/code-credentials`, options);
}

export function getFaceIdConfiguration (companyId, options = {}) {
	return api.get(`/companies/${companyId}/configurations/face-id`, options);
}

export function getQrCodeConfiguration (companyId, options = {}) {
	return api.get(`/companies/${companyId}/configurations/qr-codes`, options);
}

export function getNfcConfiguration (companyId, options = {}) {
	return api.get(`core/v3/companies/${companyId}/nfc-configuration`, {
		namespace: 'private',
		...options,
	});
}
